import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const SESSION_KEY = "rsi_analytics_session_id";
const LAST_HIT_KEY = "rsi_analytics_last_hit";

function getSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = `sess-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    const now = Date.now();
    const last = sessionStorage.getItem(LAST_HIT_KEY);
    if (last) {
      try {
        const parsed = JSON.parse(last);
        if (parsed.path === path && now - parsed.ts < 1500) return;
      } catch {
        // Ignore malformed session cache.
      }
    }
    sessionStorage.setItem(LAST_HIT_KEY, JSON.stringify({ path, ts: now }));

    api.post("/analytics/pageview", {
      path,
      title: document.title || "",
      referrer: document.referrer || "",
      session_id: getSessionId(),
      language: navigator.language || "",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      screen_width: window.screen?.width || 0,
      screen_height: window.screen?.height || 0,
    }).catch(() => {
      // Analytics should never block page rendering.
    });
  }, [location.hash, location.pathname, location.search]);

  return null;
}
